import {API_DRIVER} from "../config/axios";

const getClientsRequestUrl = (endpointUrl: string) => {
    return `/api/clients${endpointUrl}`
}

export interface IClientCreateEdit {
    name: string
    company_logo: string
    is_active: boolean
    is_contractor: boolean
    contact: string | null
}

export interface ICreateClientUser {
    id?: string
    client_id?: string
    email: string
    full_name: string
}

const ClientService = {
    fetchClients: () => {
        return API_DRIVER.get(getClientsRequestUrl(""))
    },
    fetchClientById: (id: string) => {
        return API_DRIVER.get(getClientsRequestUrl(`/${id}`))
    },
    createClient: (body: IClientCreateEdit) => {
        return API_DRIVER.post(getClientsRequestUrl(``), body)
    },
    updateClient: (id: string, body: IClientCreateEdit) => {
        return API_DRIVER.put(getClientsRequestUrl(`/${id}`), body)
    },
    inviteClientUser: (clientId: string, body: ICreateClientUser) => {
        return API_DRIVER.post(getClientsRequestUrl(`/${clientId}/invite`), body)
    },
    fetchRelatedVouchers: (code: string) => {
        return API_DRIVER.get(getClientsRequestUrl('/vouchers/related'), {
            params: {
                code_hex: code
            }
        })
    },
    redeemVoucher: (codes: string[]) => {
        return API_DRIVER.put(getClientsRequestUrl('/vouchers/redeem'), {
            codes
        })
    },
    updateTicketComment: (codes: string[], comment: string) => {
        return API_DRIVER.put(getClientsRequestUrl(`/tickets/comments`), {
            codes,
            comment
        })
    },
    generateReport: (date: string) => {
        return API_DRIVER.get(getClientsRequestUrl(`/download/report`), {
            params: {
                year_month: date
            }
        })
    }
}

export default ClientService
